<div class="task-bar-chart">
    <p-chart
        #chart type="bar"
        [data]="chartData"
        [options]="chartOptions"
        [height]="isExpanded ? chartHeight : collapsedChartHeight"
        *ngIf="chartData && chartData.labels && chartData.labels.length"
    ></p-chart>
</div>
<div class="legend-paginator-row" *ngIf="(isExpanded && showLegend && legendItems.length) || paginate">
    <div class="custom-legend-container" *ngIf="isExpanded && showLegend && legendItems.length">
        <div
            *ngFor="let item of legendItems"
            class="legend-item"
            [class.is-hidden]="item.hidden"
            (click)="toggleLegendItem(item.index)"
        >
            <span class="legend-color-box" [style.background-color]="item.color" [class.disabled]="item.hidden"></span>
            <span class="legend-label" [style.text-decoration]="item.hidden ? 'line-through' : 'none'">{{ item.label }}</span>
        </div>
    </div>
    <div class="paginator-controls" [class.compact]="!isExpanded" *ngIf="paginate">
        <p-select [options]="options" optionLabel="label" optionValue="value" [(ngModel)]="rows2" (ngModelChange)="onRowsChange()" appendTo="body" />
        <p-paginator [first]="first2" [rows]="rows2" [totalRecords]="paginatorLength" (onPageChange)="onPageChange($event)" [showCurrentPageReport]="true"
            currentPageReportTemplate="{first} - {last} of {totalRecords}" [showPageLinks]="false" [showFirstLastIcon]="false" ></p-paginator>
    </div>
</div>
